import { FaSpinner } from 'react-icons/fa';
import './Spinner.styles.css';

export type LoadingProps = {
    title?: string;
    loading: boolean;
    showIcon?: boolean;
    children?: JSX.Element;
}
const Spinner: React.FC<LoadingProps> = ({ title = "Carregando, aguarde...", loading = false, showIcon = true, children }) => {
    return <div className={`spinner-container${!loading ? "-stopped" : ""}`}>
        {loading && <h1>{showIcon && <FaSpinner className="spinner" />} {title}</h1>}
        <div className={`spinner-children${!loading ? "-stopped" : ""}`}>
            {children}
        </div>
    </div>
}

export default Spinner;